import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Styled from './styles';

export interface AlertBarProps extends React.ComponentPropsWithRef<'div'> {
  /** The variant of the alert. */
  variant?: 'CONFIRM' | 'ERROR' | 'WARNING';
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}
export interface ThemeShape {
  ALERTS: Record<string, unknown>
}

/** All other props will be provided to the wrapper element. */
const AlertBar = React.forwardRef<HTMLElement, AlertBarProps>((props, ref) => getContext(({ RTL, theme } : { theme: ThemeShape, RTL: boolean }) => {
  const {
    variant,
    theme: themeProp,
    ...otherProps
  } = props;
  const resolvedTheme: Record<string, unknown> = _merge({}, theme ? theme.ALERTS : {}, themeProp);
  return <Styled.AlertBar ref={ref} $rtl={RTL} {...otherProps} $theme={variant && resolvedTheme[variant]} />;
}));

AlertBar.displayName = 'AlertBar';

AlertBar.defaultProps = {
  variant: 'CONFIRM',
  // TODO: not sure why this is being flagged for a required prop when 'theme' is optional
  // eslint-disable-next-line react/default-props-match-prop-types
  theme: {}
};

export default AlertBar;
